<template>
  <div class="row">
    <div class="col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <h5>Team Members</h5>
            <div>
              <a href="javascript:void(0);" class="btn btn-light btn-sm">View All</a>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="avatar flex-shrink-0">
                <img
                  src="@/assets/img/users/user-27.jpg"
                  class="rounded-circle border border-2"
                  alt="img"
                />
              </a>
              <div class="ms-2">
                <h6 class="fs-14 fw-medium text-truncate mb-1">
                  <a href="javascript:void(0);">Alexander Jermai</a>
                </h6>
                <p class="fs-13">UI/UX Designer</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-phone fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-mail-bolt fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm"
                ><i class="ti ti-brand-hipchat fs-16"></i
              ></a>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="avatar flex-shrink-0">
                <img
                  src="@/assets/img/users/user-42.jpg"
                  class="rounded-circle border border-2"
                  alt="img"
                />
              </a>
              <div class="ms-2">
                <h6 class="fs-14 fw-medium text-truncate mb-1">
                  <a href="javascript:void(0);">Doglas Martini</a>
                </h6>
                <p class="fs-13">Product Designer</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-phone fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-mail-bolt fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm"
                ><i class="ti ti-brand-hipchat fs-16"></i
              ></a>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="avatar flex-shrink-0">
                <img
                  src="@/assets/img/users/user-43.jpg"
                  class="rounded-circle border border-2"
                  alt="img"
                />
              </a>
              <div class="ms-2">
                <h6 class="fs-14 fw-medium text-truncate mb-1">
                  <a href="javascript:void(0);">Daniel Esbella</a>
                </h6>
                <p class="fs-13">Project Manager</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-phone fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-mail-bolt fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm"
                ><i class="ti ti-brand-hipchat fs-16"></i
              ></a>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="avatar flex-shrink-0">
                <img
                  src="@/assets/img/users/user-11.jpg"
                  class="rounded-circle border border-2"
                  alt="img"
                />
              </a>
              <div class="ms-2">
                <h6 class="fs-14 fw-medium text-truncate mb-1">
                  <a href="javascript:void(0);">Daniel Esbella</a>
                </h6>
                <p class="fs-13">Team Lead</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-phone fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-mail-bolt fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm"
                ><i class="ti ti-brand-hipchat fs-16"></i
              ></a>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="avatar flex-shrink-0">
                <img
                  src="@/assets/img/users/user-44.jpg"
                  class="rounded-circle border border-2"
                  alt="img"
                />
              </a>
              <div class="ms-2">
                <h6 class="fs-14 fw-medium text-truncate mb-1">
                  <a href="javascript:void(0);">Stephan Peralt</a>
                </h6>
                <p class="fs-13">Team Lead</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-phone fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-mail-bolt fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm"
                ><i class="ti ti-brand-hipchat fs-16"></i
              ></a>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="avatar flex-shrink-0">
                <img
                  src="@/assets/img/users/user-54.jpg"
                  class="rounded-circle border border-2"
                  alt="img"
                />
              </a>
              <div class="ms-2">
                <h6 class="fs-14 fw-medium text-truncate mb-1">
                  <a href="javascript:void(0);">Andrew Jermia</a>
                </h6>
                <p class="fs-13">Project Lead</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-phone fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm me-2"
                ><i class="ti ti-mail-bolt fs-16"></i
              ></a>
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm"
                ><i class="ti ti-brand-hipchat fs-16"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <h5>Notifications</h5>
            <div>
              <a href="javascript:void(0);" class="btn btn-light btn-sm">View All</a>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="d-flex align-items-start mb-4">
            <a href="javascript:void(0);" class="avatar flex-shrink-0">
              <img
                src="@/assets/img/users/user-27.jpg"
                class="rounded-circle border border-2"
                alt="img"
              />
            </a>
            <div class="ms-2">
              <h6 class="fs-14 fw-medium text-truncate mb-1">
                Lex Murphy requested access to UNIX
              </h6>
              <p class="fs-13 mb-2">Today at 9:42 AM</p>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="avatar avatar-sm border flex-shrink-0 me-2"
                  ><img
                    src="@/assets/img/social/pdf-icon.svg"
                    class="w-auto h-auto"
                    alt="Img"
                /></a>
                <h6 class="fw-normal"><a href="javascript:void(0);">EY_review.pdf</a></h6>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start mb-4">
            <a href="javascript:void(0);" class="avatar flex-shrink-0">
              <img
                src="@/assets/img/users/user-28.jpg"
                class="rounded-circle border border-2"
                alt="img"
              />
            </a>
            <div class="ms-2">
              <h6 class="fs-14 fw-medium text-truncate mb-1">
                Lex Murphy requested access to UNIX
              </h6>
              <p class="fs-13 mb-0">Today at 10:00 AM</p>
            </div>
          </div>
          <div class="d-flex align-items-start mb-4">
            <a href="javascript:void(0);" class="avatar flex-shrink-0">
              <img
                src="@/assets/img/users/user-29.jpg"
                class="rounded-circle border border-2"
                alt="img"
              />
            </a>
            <div class="ms-2">
              <h6 class="fs-14 fw-medium text-truncate mb-1">
                Lex Murphy requested access to UNIX
              </h6>
              <p class="fs-13 mb-2">Today at 10:50 AM</p>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="btn btn-primary btn-sm me-2">Approve</a>
                <a href="javascript:void(0);" class="btn btn-outline-primary btn-sm">Decline</a>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start mb-4">
            <a href="javascript:void(0);" class="avatar flex-shrink-0">
              <img
                src="@/assets/img/users/user-30.jpg"
                class="rounded-circle border border-2"
                alt="img"
              />
            </a>
            <div class="ms-2">
              <h6 class="fs-14 fw-medium text-truncate mb-1">
                Lex Murphy requested access to UNIX
              </h6>
              <p class="fs-13 mb-0">Today at 12:00 PM</p>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <a href="javascript:void(0);" class="avatar flex-shrink-0">
              <img
                src="@/assets/img/users/user-33.jpg"
                class="rounded-circle border border-2"
                alt="img"
              />
            </a>
            <div class="ms-2">
              <h6 class="fs-14 fw-medium text-truncate mb-1">
                Lex Murphy requested access to UNIX
              </h6>
              <p class="fs-13 mb-0">Today at 05:00 PM</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
          >
            <h5>Meetings Schedule</h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>Today
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >This Month</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >This Year</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body schedule-timeline">
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:25 AM</span>
              <span><i class="ti ti-point-filled text-primary fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 pb-4 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Marketing Strategy Presentation</p>
                <span>Marketing</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:20 AM</span>
              <span><i class="ti ti-point-filled text-secondary fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 pb-4 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">
                  Design Review Hospital, doctors Management Project
                </p>
                <span>Review</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:18 AM</span>
              <span><i class="ti ti-point-filled text-warning fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 pb-4 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Birthday Celebration of Employee</p>
                <span>Celebration</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:10 AM</span>
              <span><i class="ti ti-point-filled text-success fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Update of Project Flow</p>
                <span>Development</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
